<template>
    <div class="container">
        <div class="question" :class="!question.studentAnswer ? 'grey' : ''" v-text="question.stem"></div>
        <div class="stem-pictures" v-if="question.picType == 1 || question.picType == 2" :class="!question.studentAnswer ? 'background-grey' : ''">
            <img ref='aaa' class="pic" v-if ="question.stemPic" :src="question.stemPic" :onerror="logo"/>
    </div>
    <ul class="choices">
            <li v-for="choice in question.itemsDtoList"
                :class="choice.itemKey == question.correctAnswer ? 'blue' : choice.itemKey == question.studentAnswer ? 'red' : ''">
                <span class="title"> <span class="option">{{choice.itemKey}}</span>{{ choice.itemValue}} </span>
                <div class="img-pic"
                     :class="[(!question.studentAnswer ? 'background-grey' : ''),(choice.itemKey == question.correctAnswer ? 'blue' : choice.itemKey == question.studentAnswer ? 'red' : '')]"
                     v-if="question.picType == 1 || question.picType == 3">
                    <img class="pic" v-if ="choice.itemPic" :src="choice.itemPic" :onerror="logo"/>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            question: {
                type: Object,
                required: true
            }
        },
        data: function () {
            return {
                logo: 'this.style.display="none"'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/styles/variable";
    @import "../assets/styles/mixin";

    .container {
        margin-top: 20px;
        width: 100%;
        .question {
            font-family: Helvetica-Bold, sans-serif;
            font-size: 15px;
            color: $color-text-black;
            font-weight: bold;
            @include ellipsis(2);
            &.grey {
                color: $color-text-grey;
            }
        }
        .background-grey {
            background: #E4E9EE;
            opacity: 0.6;
        }
        .pic {
            position: absolute;
            max-width: 98%;
            max-height: 98%;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
        }
        .stem-pictures {
            position: relative;
            width: 230px;
            text-align: center;
            height: 130px;
            overflow: hidden;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            margin: 20px 0;
        }
        .choices {
            margin-top: 11px;
            padding: 0;
            list-style: none;
            li {
                display: inline-block;
                width: 50%;
                font-size: 15px;
                letter-spacing: 0.12px;
                line-height: 17px;
                margin: 5px 0;
                color: $color-text-grey;
                &.red {
                    color: $color-text-red;
                }
                &.blue {
                    color: $color-text-blue;
                }
                .title {
                    @include ellipsis(2);
                }
                .option {
                    margin-right: 11px;
                }
                .img-pic {
                    position: relative;
                    width: 140px;
                    text-align: center;
                    height: 140px;
                    overflow: hidden;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    margin: 16px 0;
                    &.red {
                        border: 1px solid $color-text-red !important;
                    }
                    &.blue {
                        border: 1px solid $color-text-blue !important;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ChoiceCard.vue